module.exports = __webpack_public_path__ + "h5/img/mfe_05.05145140.jpeg";